import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Alert } from 'react-bootstrap';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Helmet } from 'react-helmet';
import IconUpdate from '../elements/IconUpdate';
import { storage } from '../firebase/firebaseConfig';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { useAuth } from '../context/AuthContext';
import Titulo from '../elements/Titulo';
import Pagination from './Pagination';


const Items = () => {

    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [image, setImage] = useState(null);
    const [dataResponse, setResponseData] = useState([]);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Cargar items desde la API al montar el componente
    useEffect(() => {
        getItems();
    }, []);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(items.length / itemsPerPage);

    const metadata = {
        contentType: 'image/jpeg'
    };

    const handleImageUpload = async (callback) => {
        if (image) {

            const newFileName = `image_${Date.now()}.${image.name.split('.').pop()}`;
            const storageRef = ref(storage, `items/${newFileName}`);
            const uploadTask = uploadBytesResumable(storageRef, image, metadata);

            uploadTask.on('state_changed',
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case 'paused':
                            console.log('Upload is paused');
                            break;
                        case 'running':
                            console.log('Upload is running');
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    console.log(error.code);
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                            // User doesn't have permission to access the object
                            break;
                        case 'storage/canceled':
                            // User canceled the upload
                            break;

                        // ...

                        case 'storage/unknown':
                            // Unknown error occurred, inspect error.serverResponse
                            break;

                        default:
                            break;
                    }
                },
                () => {
                    // Upload completed successfully, now we can get the download URL
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        callback(downloadURL);
                    });
                }
            );
        }
    };
    const getItems = async () => {
        await dotoniwoofApi.get(`/item.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setItems(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };

    // Función para abrir el modal con el ítem seleccionado
    const handleEdit = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };


    // Función para cerrar el modal
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
    };

    // Función para guardar los cambios del item editado
    const handleSaveChanges = () => {
        handleImageUpload((imageUrl) => {
            const updatedItems = items.map(item =>
                item.id_item === selectedItem.id_item ? selectedItem : item
            );
            updateItemApi(imageUrl, updatedItems);
            setShowModal(false)
        });
    };

    const updateItemApi = async (url, updatedItems) => {
        console.log(updatedItems);
        console.log(selectedItem);
        try {
            const { data } = await dotoniwoofApi.put(`/item.php/${selectedItem.id_item}`,
                JSON.stringify({
                    firebase_UID: user.uid,
                    description: selectedItem.description,
                    url: url
                }));
            setResponseData(data);
            if (data.code === 201) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                getItems();
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000);
        }
    }

    // Función para filtrar los ítems según el término de búsqueda
    const filteredItems = items.filter((item) => {
        return (
            item.product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });

    // Función para manejar los cambios en el formulario del modal
    const handleFormChange = (e) => {
        setSelectedItem({ ...selectedItem, [e.target.name]: e.target.value });
    };

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };

    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Items
            </title></Helmet>


            <div className="container">
                {/* Alerta de confirmación de éxito */}
                {showSuccessAlert && (
                    <Alert variant="success">
                        {dataResponse.message}
                    </Alert>
                )}

                {/* Alerta de error */}
                {showErrorAlert && (
                    <Alert variant="danger">
                        {dataResponse.message}
                    </Alert>
                )}
                <Titulo>Actualizacion de items</Titulo>
                <h3 className="mt-4">Lista de items</h3>

                {/* Buscador */}
                <Form.Group className="mb-3" controlId="search">
                    <Form.Label><strong>Buscar Productos</strong></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Escriba el nombre del producto"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Form.Group>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginate={paginate}
                />
                <br></br>
                <Table striped bordered hover className="mt-3">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Color</th>
                            <th>Tamaño</th>
                            <th>Peso</th>
                            <th>Imagen</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredItems.map((item) => (
                            <tr key={item.id_item}>
                                <td>{item.description}</td>
                                <td>{item.color.color_name}</td>
                                <td>{item.size.size_name}</td>
                                <td>{item.weight.weight_name}</td>
                                <td><img src={item.url} alt={item.product.name} style={{
                                    height: '50px'
                                }}></img></td>
                                <td>
                                    <Button variant="warning" className="me-2" onClick={() => handleEdit(item)}><IconUpdate></IconUpdate></Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Modal para editar el ítem */}
                {selectedItem && (
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Editar Item</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group controlId="formItemName">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="description"
                                        value={selectedItem.description}
                                        onChange={handleFormChange}
                                    />
                                </Form.Group>
                                <br></br>
                                <Form.Group controlId="formImage">
                                    <Form.Label><strong>Imagen del item</strong></Form.Label>
                                    <Form.Control type="file" onChange={handleImageChange} required />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
                            <Button variant="primary" onClick={handleSaveChanges}>Guardar</Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>


        </>

    );
}

export default Items;